import React, { useState, useRef } from 'react';
import {
  useInstantSearch,
  useSearchBox,
  UseSearchBoxProps
} from 'react-instantsearch';

import { useSearchListContext } from '../context/SearchListProvider';

const SearchInput = (props: UseSearchBoxProps) => {
  const { query, refine } = useSearchBox(props);
  const { status } = useInstantSearch();
  const { i18n } = useSearchListContext();

  const [value, setValue] = useState(query);
  const ref = useRef<HTMLInputElement>(null);

  const isSearchStalled = status === 'stalled';

  const setQuery = (q: string) => {
    setValue(q);
    refine(q);
  };

  return (
    <form
      role="search"
      className="search-list__input"
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        if (ref.current) ref.current.blur();
      }}
      onReset={(event) => {
        event.preventDefault();
        event.stopPropagation();
        setQuery('');

        if (ref.current) ref.current.focus();
      }}
    >
      <div className="search-list__input-wrapper">
        <input
          ref={ref}
          className="typo-headline-4"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder={i18n.searchQuery}
          spellCheck={false}
          maxLength={512}
          type="search"
          value={value}
          onChange={(event) => setQuery(event.currentTarget.value)}
          autoFocus
        />

        <button
          type="reset"
          hidden={value.length === 0 || isSearchStalled}
          title={i18n.resetSearch}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.9395 0.939453L15.0608 3.06077L10.1214 8.0001L15.0608 12.9395L12.9395 15.0608L8.0001 10.1214L3.06077 15.0608L0.939453 12.9395L5.8788 8.0001L0.939453 3.06077L3.06077 0.939453L8.0001 5.8788L12.9395 0.939453Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>

      <button type="submit" title={i18n.submitSearch}>
        <svg
          width="31"
          height="30"
          viewBox="0 0 31 30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="Vector"
            d="M15.6392 7L14.2292 8.41L19.8092 14H7.63916V16H19.8092L14.2292 21.59L15.6392 23L23.6392 15L15.6392 7Z"
            fill="currentColor"
          />
          <circle
            id="Ellipse 82"
            cx="15.6391"
            cy="15.0004"
            r="14.5141"
            fill="none"
            stroke="currentColor"
          />
        </svg>
      </button>

      <span hidden={!isSearchStalled}>Searching…</span>
    </form>
  );
};

export default SearchInput;
